export default {
  // Menú principal
  menu: 'Menú',

  // Gestión Administrativa
  administrativeManagement: 'Gestión Administrativa',
  institution: 'Institución',
  users: 'Usuarios',
  evaluations: 'Evaluaciones',

  // Recursos
  alternativeNames: 'Nombres Alternativos',
}
